import React from 'react';
import { useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import {
  selectListingSelectedDoors,
  selectListingSelectedHistory,
  selectListingSelectedOpenHouses,
  selectListingSelectedParcels,
  selectListingSelectedPhotos,
  selectListingSelectedRooms,
  selectListingSelectedSupplements,
  selectListingSelectedUnits,
} from '@redux/selectors/ListingSelector';
import { selectAgentPhotos } from '@redux/selectors/AgentSelector';
import Address from './Address';
import AgentLookup from './agentLookup/AgentLookup';
import LincNumberGenerator from './lincNumberGenerator/LincNumberGenerator';
import LocationPlotter from './locationPlotter/LocationPlotter';
import OfficeLookup from './officeLookup/OfficeLookup';
import OneDMeasurement from './OneDMeasurement';
import TwoDMeasurement from './TwoDMeasurement';
import SupplementGrid from './supplements/SupplementGrid';
import ImageCropper from '../imageCropper/ImageCropper';
import RepeatableRoom from '../repeatableRoom/RepeatableRoom';
import RepeatableOpenHouse from './openHouse/RepeatableOpenHouse';
import RepeatableParcels from './parcels/RepeatableParcels';
import RepeatableDoors from './doors/RepeatableDoors';
import RepeatableUnits from './units/RepeatableUnits';
import RepeatableHistory from './history/RepeatableHistory';

// TODO: In the future, test this component alongside with https://github.com/welldone-software/why-did-you-render
const LayoutGroupWrapper = ({ groupType, resourceType = 'listing', ...props }) => {
  let photosPayload;

  const listingPhotos = useSelector(selectListingSelectedPhotos);
  const agentPhotos = useSelector(selectAgentPhotos);
  if (resourceType === 'listing') photosPayload = listingPhotos;
  else photosPayload = agentPhotos;

  const supplementsPayload = useSelector(selectListingSelectedSupplements);
  const roomsPayload = useSelector(selectListingSelectedRooms);
  const parcelsPayload = useSelector(selectListingSelectedParcels);
  const unitsPayload = useSelector(selectListingSelectedUnits);
  const doorsPayload = useSelector(selectListingSelectedDoors);
  const openHousesPayload = useSelector(selectListingSelectedOpenHouses);
  const historyPayload = useSelector(selectListingSelectedHistory);

  switch (groupType) {
    case 'Address':
      return <Address {...props} />;
    case 'AgentLookup':
      return <AgentLookup {...props} />;
    case 'History':
      return <RepeatableHistory {...props} historyPayload={historyPayload} />;
    case 'LincNumberGenerator':
      return <LincNumberGenerator {...props} />;
    case 'LoadingDoors':
      return <RepeatableDoors {...props} doorsPayload={doorsPayload} />;
    case 'LocationPlotter':
      return <LocationPlotter {...props} />;
    case 'OneDimensionalMeasurement':
      return <OneDMeasurement {...props} />;
    case 'OpenHouse':
      return <RepeatableOpenHouse {...props} openHousesPayload={openHousesPayload} />;
    case 'OfficeLookup':
      return <OfficeLookup {...props} />;
    case 'Parcels':
      return <RepeatableParcels {...props} parcelsPayload={parcelsPayload} />;
    case 'Photos':
      return <ImageCropper {...props} photosPayload={photosPayload} />;
    case 'Rooms':
      return <RepeatableRoom roomsPayload={roomsPayload} />;
    case 'Supplements':
      return <SupplementGrid {...props} supplementsPayload={supplementsPayload} />;
    case 'TwoDimensionalMeasurement':
      return <TwoDMeasurement {...props} />;
    case 'Units':
      return <RepeatableUnits {...props} unitsPayload={unitsPayload} />;
    default:
      return null;
  }
};

LayoutGroupWrapper.propTypes = {
  groupType: PropTypes.string.isRequired,
  resourceType: PropTypes.string,
};

export default LayoutGroupWrapper;
